import {
  NIST_FACE_SCENARIO_TABLE5_FUSION,
  NIST_FACE_SCENARIO_TABLE6_MULTI_FACE,
  NIST_IRIS_SCENARIO_K_FRAME,
} from './nistConstants';

export function buildNistFaceExtractSummary(scenario, meta, templateCount, inputImageCount) {
  const inputs = meta?.inputImageCount ?? inputImageCount ?? 1;
  const templates = meta?.templateCount ?? templateCount ?? 0;
  const facesDetected = meta?.facesDetected ?? templates;
  const facesExtracted = meta?.facesExtracted ?? templates;

  if (scenario === NIST_FACE_SCENARIO_TABLE5_FUSION) {
    return {
      title: 'K-frame fusion complete',
      description: `Fused ${inputs} input image(s) into 1 BCHQ template.`,
      detail: templates === 1 ? 'One fused enrollment template returned.' : `Returned ${templates} template(s); expected 1.`,
    };
  }

  if (scenario === NIST_FACE_SCENARIO_TABLE6_MULTI_FACE) {
    return {
      title: 'Group photo extract complete',
      description: `Detected ${facesDetected} face(s) and extracted ${facesExtracted} BCHQ template(s) from 1 image.`,
      detail:
        facesDetected === facesExtracted
          ? 'Each detected face has a corresponding BCHQ template.'
          : `Extracted ${facesExtracted} of ${facesDetected} detected face(s).`,
    };
  }

  return {
    title: 'Extraction complete',
    description: `Extracted ${templates} BCHQ template(s) from ${inputs} image(s).`,
    detail: null,
  };
}

export function buildNistIrisExtractSummary(scenario, templateCount, inputImageCount) {
  if (scenario === NIST_IRIS_SCENARIO_K_FRAME) {
    return {
      title: 'K-frame enroll complete',
      description: `Fused ${inputImageCount} iris frame(s) into 1 template (BCHI when fusion is enabled).`,
      detail: templateCount === 1 ? 'One fused enrollment template returned.' : `Returned ${templateCount} template(s); expected 1.`,
    };
  }
  return {
    title: 'Extraction complete',
    description: `Extracted ${templateCount} iris template(s) from ${inputImageCount} image(s).`,
    detail: null,
  };
}
